import React, { Component } from 'react';
import {connect} from "react-redux";
import {toggleDropBox} from "../actions";
import Switch from '@material-ui/core/Switch';
import classNames from 'classnames'
import Icon from '@material-ui/core/Icon';




const ListHeader = ({ editUserLineUpdateTime, toggleOnlyActive, onlyActive, open, closeListHeader, searchLine, settings  }) => {
    const dropClass = classNames({
        'list-header': true,
        'active': open,
    });



    const listPageRender = (
        <div className={dropClass}>
            <div className='content-center'>
                <div className="list-header__wrap">
                    {/*<button onClick={editUserLineUpdateTime}>
                        <div className="list-header__refresh-lines-time-wrap">
                            <div className="list-header__refresh-lines-time-icon"></div>
                            <div className="list-header__refresh-lines-time-hint"> Отметить все</div>
                        </div>
                    </button>

                    <div className="list-header__border"></div>*/}

                    <div className="list-header__refresh-lines-time-wrap">
                        <div className="list-header__left-block">
                            <Switch
                                checked={Boolean(onlyActive)}
                                onChange={toggleOnlyActive}
                                id='toggleOnlyActive'
                                //color="primary"
                            />
                        </div>
                        <label htmlFor="toggleOnlyActive" className="list-header__refresh-lines-time-hint"> Показывать
                            только активные </label>
                    </div>

                    <div className="list-header-btn list-header-btn_close">
                        <button onClick={closeListHeader}>
                            <Icon>close</Icon>
                        </button>
                    </div>

                    <div className="search-list search-list_line">
                        <div className="search-list__wrap">
                            <input   onChange={searchLine} className='search-list__input' placeholder='Search line' type="text"/>
                            <span className='search-list__btn color_blue'>
                                    <Icon>search</Icon>
                                </span>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )


    return listPageRender

}


const mapStateToProps = state => ({
    title: state.title,
    savedListsNotification: state.savedListsNotification,
})
const mapDispatchToProps = {
    toggleDropBox,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListHeader);


// WEBPACK FOOTER //
// ./src/components/ListHeader.js